<template>
  <div>
    <div class="container">
      <div class="warp content">
        <el-row
          type="flex"
          class="row-bg hidden-md-and-down footer-row"
          justify="space-between"
        >
          <el-col :span="6">
            <div class="grid-content bg-purple">
              <h4>产品中心</h4>
              <P v-for="(item, index) in product" :key="index">
                {{ item }}
              </P>
            </div>
          </el-col>
          <el-col :span="5">
            <div class="grid-content bg-purple-light">
              <h4>联系我们</h4>
              <p v-for="(item, index) in relation" :key="index">
                {{ item }}
              </p>
            </div>
          </el-col>
          <el-col :span="7">
            <div class="grid-content bg-purple follow-us">
              <h4>关注我们</h4>
              <div class="qr-code-container">
                <div class="qr-item">
                  <span style="margin-bottom: 10px; white-space: nowrap;"
                    >APP下载</span
                  >
                  <img
                    src="../../assets/QRcode/android.jpg"
                    alt="APP下载"
                  />
                </div>
                <div class="qr-item qr-item-right">
                  <span style="margin-right: 0px; margin-bottom: 10px;white-space: nowrap;"
                    >微信公众号</span
                  >
                  <img
                    src="../../assets/QRcode/Official.png"
                    alt="微信公众号"
                  />
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
      <div class="contentFoot hidden-lg-and-up">
        <el-collapse v-model="activeNames" @change="handleChange" accordion>
          <el-collapse-item title="产品中心" name="1">
            <div>
              <P v-for="(item, index) in product" :key="index">
                {{ item }}
              </P>
            </div>
          </el-collapse-item>
          <el-collapse-item title="联系我们" name="2">
            <div>
              <p
                style="width: 18.75rem"
                v-for="(item, index) in relation"
                :key="index"
              >
                {{ item }}
              </p>
            </div>
          </el-collapse-item>
          <el-collapse-item title="关注我们" name="3">
            <div>
              <div style="text-align: center">
                <div>
                  <p>APP下载</p>
                  <img
                    style="width: 6.25rem"
                    src="../../assets/QRcode/android.jpg"
                    alt=""
                  />
                </div>
                <div>
                  <p>微信公众号</p>
                  <img
                    style="width: 6.25rem"
                    src="../../assets/QRcode/Official.png"
                    alt=""
                  />
                </div>
              </div>
            </div>
          </el-collapse-item>
        </el-collapse>
      </div>
      <div class="footer-bottom">
        <p>
          <img src="../../assets/gg.png" alt="" /> &nbsp;
          <a
            href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31010102006642"
            target="_blank"
          >
            沪公网安备 31010102006642号
          </a>
          &nbsp; &nbsp;
          <a href="http://beian.miit.gov.cn/" target="_blank"
            >沪ICP备17026007号-4</a
          >
        </p>
        <p>Copyright@2017-2019 宇起数字科技（上海）有限公司版权所有</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Footer",
  data() {
    return {
      product: [
        "智能指纹密码器  Y01P",
        "智能指纹办公抽屉柜锁  Y03B",
        "智能指纹办公抽屉柜锁  Y03L",
      ],
      relation: {
        phone: "电话： 021-55220166",
        time: "工作时间： 周一至周五（9:00-18:00）",
        Email: "邮箱： yuqi@yuqidata.com",
        company: "公司： 宇起数字科技（上海）有限公司",
      },
      activeNames: ["0"],
    };
  },
  methods: {
    handleChange(val) {},
  },
};
</script>

<style lang="scss" scoped>
.container {
  padding-top: 0.625rem;
  background-color: black;
  color: #fff;

  p {
    margin: 0.625rem 0;
    min-width: 9.5rem;
    word-wrap: break-word;
    overflow-wrap: break-word;
  }

  .content {
    ::v-deep .el-row.footer-row {
      flex-wrap: nowrap !important;
      padding-bottom: 1.25rem;
      position: inherit;
      border-bottom: 1px solid #363636;
    }

    ::v-deep .el-col {
      flex-shrink: 1;
      min-width: 0;
    }

    .grid-content {
      word-wrap: break-word;
      overflow-wrap: break-word;
      box-sizing: border-box;

      p,
      P {
        word-wrap: break-word;
        overflow-wrap: break-word;
        white-space: normal;
      }

      &.follow-us {
        max-width: 100%;
        box-sizing: border-box;

        .qr-code-container {
          display: flex;
          justify-content: space-between;
          align-items: center;
          gap: 0.9375rem;
          max-width: 100%;
          box-sizing: border-box;
          // flex-wrap: wrap;

          .qr-item {
            display: flex;
            flex-direction: column;
            align-items: anchor-center;
            flex-shrink: 1;
            min-width: 0;
            max-width: calc(50% - 0.46875rem);
            box-sizing: border-box;
            text-align: center;
            margin-left: 55px;

            &.qr-item-right {
              margin-left: auto;
            }

            p {
              word-wrap: break-word;
              overflow-wrap: break-word;
              white-space: normal;
              text-align: center;
              max-width: 100%;
            }

            img {
             
              max-width: 100%;
              width: 6.25rem;
              height: auto;
              box-sizing: border-box;
            }
          }
        }
      }
    }
  }

  .contentFoot {
    padding: 0 1.25rem;

    div {
      background-color: #000;
      color: #fff;
    }
  }

  .footer-bottom {
    text-align: center;
    padding-bottom: 0.625rem;
    color: #858585;
    font-size: 0.75rem;
  }
}

::v-deep .el-collapse-item__header {
  background-color: #000;
  border-bottom: 1px solid #363636;
  color: #fff;
}

::v-deep .el-collapse-item__wrap {
  background-color: #000;
  border-bottom: 1px solid #363636;
}

::v-deep .el-collapse {
  border-top: 1px solid #363636;
}
</style>
